import React from 'react';
import axios from "../../containers/api";
import {Alert, Button, FormGroup, Input, Label} from "reactstrap";
import { showCatchError, toEnglishNumbers } from "../../helpers/Utils";

class ChangePassDriver extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newPassword: "",
            errors: [],
            oneDriver: this.props && this.props.driver
        }
        console.log(this.props.driver);
    }

     
     
    ChangePassDriver = () => {
        this.props.closeSweetAlert();
        if (this.state.newPassword !== "" && this.state.newPassword.length < 6) {
            this.props.showAlert("رمز عبور باید حداقل 6 حرف ياشد ", "error");
        } else {
            this.props.showSpinner();
            //const request = {
            //    Item1: (this.state.oneDriver.id),
            //    Item2: toEnglishNumbers(this.state.newPassword),
            //    Item3: toEnglishNumbers(this.state.oneDriver.nationalId),
            //}
            //axios.post('api/v1/drivers/ChangePassDriver', request)
            let model = {
                Username: toEnglishNumbers(this.state.oneDriver.nationalId),
                Password: toEnglishNumbers(this.state.newPassword),
            }
            this.props.showSpinner();
            axios.put('/api/v1/users/admin-change-pass', model)
                .then((res) => {
                    this.props.hideSpinner();
                    this.props.showAlert(res.data.message, "success");
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        }
    };
    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام</Label>
                        <Input value={this.state.oneDriver.name} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام خانوادگی</Label>
                        <Input value={this.state.oneDriver.family} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد ملی</Label>
                        <Input value={this.state.oneDriver.nationalId} readOnly/>
                    </FormGroup>

                    
                </div>

                {this.state.errors.length === 0 ?
                    null
                    :
                    <div>
                        {(this.state.errors.map((error, i) => {
                            return (
                                <Alert color="danger" key={i}>{error}</Alert>
                            )
                        }))}
                    </div>
                }

                <div className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-20 w-100 px-1">
                        <Label>رمز جدید</Label>
                        <Input value={this.state.newPassword}
                               onChange={(e) => this.setState({newPassword: e.target.value})}/>
                    </FormGroup>

                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2"
                            onClick={() => this.props.showSweetAlert("آیا از تغییر رمز کاربری این راننده مطمئن هستید؟", "", "warning", this.ChangePassDriver)}>
                            تغییر رمز کاربری
                        </Button>
                    </FormGroup>
                </div>

            </div>
        );
    }
}

export default ChangePassDriver;